/* BYLOS — Liquid layer: press ripples, fly-to-bag, bag jelly, glass glare */
(() => {
  const d = document;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const PRESSABLE = '.btn:not(.btn--light), .size, .size-mini, .qty button, .drawer__close, .newsletter button, .lightbox__close, .lightbox__nav';

  /* Liquid drop from the exact point of contact */
  d.addEventListener('pointerdown', (e) => {
    const el = e.target.closest(PRESSABLE);
    if (!el || el.disabled) return;
    const r = el.getBoundingClientRect();
    const drop = d.createElement('span');
    const bg = getComputedStyle(el).backgroundColor;
    const m = (bg.match(/[\d.]+/g) || []).map(Number);
    const alpha = m.length > 3 ? m[3] : 1;
    const dark = alpha < 0.3 || (m[0] + m[1] + m[2]) / 3 > 140; // light or clear surface -> dark drop
    drop.className = 'liquid-drop' + (dark ? ' liquid-drop--dark' : '');
    drop.style.left = `${e.clientX - r.left}px`;
    drop.style.top = `${e.clientY - r.top}px`;
    drop.style.setProperty('--drop-scale', Math.ceil((Math.hypot(r.width, r.height) * 2.2) / 12));
    el.appendChild(drop);
    drop.addEventListener('animationend', () => drop.remove());
  }, { passive: true });

  /* Glass bubble that flies the product into the bag */
  const fly = (img) => {
    const target = d.querySelector('.site-header [data-cart-open]');
    if (!img || !target) return;
    const a = img.getBoundingClientRect();
    const b = target.getBoundingClientRect();
    if (!a.width) return;
    const size = Math.min(140, a.width * 0.45);
    const bubble = d.createElement('div');
    bubble.className = 'fly';
    bubble.innerHTML = `<img src="${img.currentSrc || img.src}" alt="">`;
    Object.assign(bubble.style, { width: `${size}px`, height: `${size}px`, left: `${a.left + a.width / 2 - size / 2}px`, top: `${a.top + a.height / 2 - size / 2}px` });
    d.body.appendChild(bubble);
    const dx = b.left + b.width / 2 - (a.left + a.width / 2);
    const dy = b.top + b.height / 2 - (a.top + a.height / 2);
    bubble.animate([
      { transform: 'translate(0,0) scale(.6)', opacity: 0 },
      { transform: 'translate(0,-24px) scale(1)', opacity: 1, offset: 0.18 },
      { transform: `translate(${dx * 0.55}px, ${dy * 0.55 - 70}px) scale(.55)`, opacity: 1, offset: 0.6 },
      { transform: `translate(${dx}px, ${dy}px) scale(.12)`, opacity: 0.2 }
    ], { duration: 850, easing: 'cubic-bezier(.5,0,.3,1)' }).onfinish = () => bubble.remove();
  };

  d.addEventListener('click', (e) => {
    const q = e.target.closest('[data-quick-add]');
    if (q && !q.disabled) {
      const holder = q.closest('.card, .upsell__item');
      fly(holder?.querySelector('img'));
    }
  }, true);

  d.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-product-form], form[action*="/cart/add"]');
    if (!form) return;
    const btn = form.querySelector('[data-add-btn]');
    if (btn && btn.disabled) return;
    const section = form.closest('[data-product]') || d;
    fly(section.querySelector('.gallery__item img'));
  }, true);

  /* "Added" morphs into a tick */
  const watchLabel = (label) => {
    const btn = label.closest('.btn');
    const sync = () => {
      const added = label.textContent.trim().toLowerCase() === 'added';
      btn.classList.toggle('is-added-state', added);
      let tick = btn.querySelector('.check');
      if (added && !tick) { tick = d.createElement('span'); tick.className = 'check'; btn.insertBefore(tick, label); requestAnimationFrame(() => btn.classList.add('is-added-state')); }
      if (!added && tick) tick.remove();
    };
    new MutationObserver(sync).observe(label, { childList: true, characterData: true, subtree: true });
  };

  /* Bag count jelly when it changes */
  const watchCounts = () => d.querySelectorAll('[data-cart-count]').forEach((n) => {
    let last = n.textContent;
    new MutationObserver(() => {
      if (n.textContent === last) return;
      last = n.textContent;
      n.classList.remove('jelly'); void n.offsetWidth; n.classList.add('jelly');
    }).observe(n, { childList: true, characterData: true, subtree: true });
  });

  /* Soft glass glare that follows the pointer across product photography */
  const glare = (e) => {
    const el = e.target.closest('.card__media, .gallery__item');
    if (!el) return;
    const r = el.getBoundingClientRect();
    el.style.setProperty('--gx', `${e.clientX - r.left}px`);
    el.style.setProperty('--gy', `${e.clientY - r.top}px`);
  };

  const boot = () => {
    d.querySelectorAll('[data-add-label]').forEach(watchLabel);
    watchCounts();
    if (matchMedia('(pointer: fine)').matches) d.addEventListener('pointermove', glare, { passive: true });
  };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
